import { EduCoursesCollectionFacade } from './edu-courses/edu-courses.facade';
import { EduCoursePaymentsCollectionFacade } from './edu-course-payments/edu-course-payments.facade';
import { TestimonialsCollectionFacade } from './testimonials/testimonials.facade';
import { SitesCollectionFacade } from './sites/sites.facade';
import { ChatBotsCollectionFacade } from './chat-bots/chat-bots.facade';
import { ChatBotChainsCollectionFacade } from './chat-bot-chains/chat-bot-chains.facade';
import { EduSchoolsCollectionFacade } from './edu-schools/edu-schools.facade';
import { EduCoursesTariffsCollectionFacade } from '@web/store/collections/edu-courses-tariffs/edu-courses-tariffs.facade';

export const CollectionsFacades = [
    EduCoursesCollectionFacade,
    EduCoursePaymentsCollectionFacade,
    TestimonialsCollectionFacade,
    SitesCollectionFacade,
    ChatBotsCollectionFacade,
    ChatBotChainsCollectionFacade,
    EduSchoolsCollectionFacade,
    EduCoursesTariffsCollectionFacade,
];
